import { Loader2, MessageSquare } from "lucide-react";

interface VCardMessagePanelProps {
  title?: string;
  description?: string;
  value: string;
  placeholder?: string;
  maxLength?: number;
  isSaving?: boolean;
  isSaveDisabled?: boolean;
  saveLabel?: string;
  status?: {
    type: "success" | "error";
    text: string;
  } | null;
  onChange: (value: string) => void;
  onSave: () => Promise<void> | void;
}

const VCardMessagePanel = ({
  title = "Message For Finder",
  description = "This message is saved to your SmartTag vCard and shown when this QR code is scanned.",
  value,
  placeholder = "e.g., If found, please call or message me. Reward offered.",
  maxLength = 300,
  isSaving = false,
  isSaveDisabled = false,
  saveLabel = "Save Message",
  status = null,
  onChange,
  onSave,
}: VCardMessagePanelProps) => (
  <div className="w-full rounded-lg border border-gray-200 bg-white p-6 shadow-md dark:border-slate-700 dark:bg-slate-900/40">
    <h2 className="mb-2 flex items-center text-lg font-semibold text-gray-900 dark:text-gray-100">
      <MessageSquare className="mr-2 h-5 w-5 text-red-600" />
      {title}
    </h2>

    <p className="mb-4 text-sm text-gray-600 dark:text-gray-300">
      {description}
    </p>

    <textarea
      value={value}
      onChange={(event) => onChange(event.target.value.slice(0, maxLength))}
      rows={5}
      maxLength={maxLength}
      className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-900 focus:border-red-500 focus:ring-2 focus:ring-red-500 dark:border-slate-700 dark:bg-slate-800 dark:text-gray-100"
      placeholder={placeholder}
    />

    <div className="mt-3 flex items-center justify-between">
      <span className="text-xs text-gray-500 dark:text-gray-400">
        {value.length}/{maxLength}
      </span>
      <button
        type="button"
        disabled={isSaving || isSaveDisabled}
        onClick={() => void onSave()}
        className="rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-red-700 disabled:cursor-not-allowed disabled:bg-red-400"
      >
        {isSaving ? (
          <span className="flex items-center">
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Saving...
          </span>
        ) : (
          saveLabel
        )}
      </button>
    </div>

    {status && (
      <p
        className={`mt-3 text-sm ${
          status.type === "success"
            ? "text-green-600 dark:text-green-400"
            : "text-red-600 dark:text-red-400"
        }`}
      >
        {status.text}
      </p>
    )}
  </div>
);

export default VCardMessagePanel;
